import { createFileRoute } from "@tanstack/react-router";
import { ConnectGCP } from "../../../features/infrastructure/cloud-connect";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/gcp")({ component: Page });

function Page() {
  const { org } = Route.useParams();
  return <ConnectGCP org={org} />;
}
